import React from "react";
import { motion } from "framer-motion";
import CountUp from "react-countup";
import { fadeUp, viewportOnce } from "./motionPresets";

const STATS = [
  { value: 120, suffix: "+", label: "Clients served" },
  { value: 8, suffix: "+", label: "Years in business" },
  { value: 250, suffix: "+", label: "Implementations" },
  { value: 4, suffix: "", label: "Product lines" },
];

const StatsBand = () => (
  <motion.section
    className="stats"
    initial="hidden"
    whileInView="visible"
    viewport={viewportOnce}
    variants={fadeUp}
  >
    <div className="stats__grid">
      {STATS.map((s) => (
        <div className="stat" key={s.label}>
          <div className="stat__value">
            <CountUp end={s.value} duration={2.2} enableScrollSpy scrollSpyOnce />
            <span>{s.suffix}</span>
          </div>
          <div className="stat__label">{s.label}</div>
        </div>
      ))}
    </div>
  </motion.section>
);

export default StatsBand;
